import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';

import rootReducer from './reducers';
import Nibelungenlied from './sagas';

let store;

export default (() => {
  if (!store) {
    const composeEnhancers =
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    const sagaMiddleware = createSagaMiddleware();

    store = createStore(
      rootReducer,
      composeEnhancers(applyMiddleware(sagaMiddleware)),
    );
    sagaMiddleware.run(Nibelungenlied);
  }

  return store;
})();
